import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_STUDENT_HOMEWORK } from "../../../Schema/HomeWork";

const useDeleteHomework = ({ handleClose, setRefetch, id }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [deleteStudentHomework] = useMutation(DELETE_STUDENT_HOMEWORK, {
    onCompleted: ({ deleteStudentHomework }) => {
      setLoading(false);
      if (deleteStudentHomework?.isSuccess === true) {
        setAlert(true, "success", deleteStudentHomework?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteStudentHomework?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteStudentHomework({
      variables: {
        id: id, 
      },
    });
  };

  return { loading, handleDelete };
};

export default useDeleteHomework;
